import React from 'react';
import { List } from '@chakra-ui/react';
import TestItem from './TestItem';
import { Test, Template } from '../../../utils/interfaces';

export interface TestListProps {
	tests: Test[];
	templates: Template[];
	calculationError: { testId: string; message: string } | null;
	onRunSimulation: (testId: string, selectedSampleId?: string) => void;
	onCalculateGroundTruth: (
		testId: string,
		selectedTemplate: string,
		selectedSample: string,
	) => void;
	handleDuplicateTest: (test: Test) => void;
	handleDeleteTest: (testId: string) => void;
	onOpenTranslationModal: (test: Test, templateRun: any) => void;
}

const TestList: React.FC<TestListProps> = ({
	tests,
	templates,
	calculationError,
	onRunSimulation,
	onCalculateGroundTruth,
	handleDuplicateTest,
	handleDeleteTest,
	onOpenTranslationModal,
}) => {
	if (!Array.isArray(tests) || tests.length === 0) {
		return null;
	}

	return (
		<List spacing={3}>
			{tests.map(test => (
				<TestItem
					key={test.testId}
					test={test}
					templates={templates}
					calculationError={calculationError}
					onRunSimulation={onRunSimulation}
					onCalculateGroundTruth={onCalculateGroundTruth}
					handleDuplicateTest={handleDuplicateTest}
					handleDeleteTest={handleDeleteTest}
					onOpenTranslationModal={onOpenTranslationModal}
				/>
			))}
		</List>
	);
};

export default React.memo(TestList);
